import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {websiteUserList_template} from "../components/templates/websiteUserList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import { is } from "@amcharts/amcharts4/core";

declare var ko: any;
declare var page: any;

export class website_users extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: websiteUserList_template;
    protected pagination: pagination_template;
    protected loaderActive: boolean = false;
    protected timer;
    protected activeExportXhrs: Array<XMLHttpRequest> = [];
    protected isExportCancelled: boolean = false;
    protected readonly EXPORT_CANCELLED_ERROR = 'EXPORT_CANCELLED';

    protected getModuleName(){

        return "website_users";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.elementsList = new websiteUserList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        //only show Add User button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Website Users List");

        return [this.elementsList.build()];
    }


    fillPage() : void{

        this.getReferences();
        this.elementsList.buildDatePickerCalendar();
    }

    protected editUser(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/website-users/edit/'+id);
    }

    protected editUserProfile(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/website-users/edit/'+id);
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected userListReorder(){

        this.filterList();
    }

    protected onShowActiveUsers() {

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDateOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(idElement = null){

        if(idElement == 'brandFilter'){
            this.elementsList.updateMasterClassRegistrationFilterItems();
        }
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        // no implementation for presist setSearchPresetsfunction
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.user;

        return templateViewModel;
    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate);

        let usrReq_url: string = '/api/website-users/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.elementsList.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.updateMailingLists(responseParsed.mailingLists);
                obj.elementsList.setBrands(responseParsed.brands);
                obj.elementsList.setMasterClassRegistrations(responseParsed.masterClassRegistrations);
                obj.elementsList.setModerationStatusFilterOptions(responseParsed.moderationStatuses);
                obj.elementsList.setPermissions(responseParsed.permissions);
                obj.elementsList.setAccessibleBrandIds(responseParsed.accessibleBrandIds);

                //set filters
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
            })
        }
    }

    public updateMailingLists(mailingLists){

        let mailingListList = [];
        for (let mailingList of mailingLists) {
            let brandAndMailingListName = `(${mailingList.shortName}) - ${mailingList.name}`;
            mailingListList.push({id: parseInt(mailingList.id), name: brandAndMailingListName});
        }

        this.elementsList.setMailingLists(mailingListList);
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected filterList(){

        //to disbable/enable user filter
        this.toggleUserFilter();

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        this.elementsList.setPaginationIsVisible(false);

        let usrReq_url: string = '/api/website-users/get';
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'website-users');
        this.updateViewModelFromPath(); //to set selected filters

        // send a second request here for pagination
        let usrReq_url2: string = '/api/website-users/getCount';
        this.sendFilterCall(usrReq_url2, subViewModel, this.onFilterCountRequestReturn, XMLHttpRequestHandler_requestType.GET, 'website-users');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                obj.loaderActive = false;
            });
        }
    }

    protected onFilterCountRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateCount(responseParsed);
            });
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let usersToSet = [];

        let data = responseParsed.paginatedResults.data;
        let users = data;
        let displayNameModeration = {};
        let displayImageModeration = {};
        let coverImageModeration = {};

        if(data && data.users){
            users = data.users;
        }

        if(data && data.displayNameModeration){
            displayNameModeration = data.displayNameModeration;
        }

        if(data && data.displayImageModeration){
            displayImageModeration = data.displayImageModeration;
        }

        if(data && data.coverImageModeration){
            coverImageModeration = data.coverImageModeration;
        }


        for (let item of users) {
            let userFullName = "";
            let displayName = "";
            let idProfile = "";
            let isVerified = false;
            let isAmazon = false;
            let isGoogle = false;
            let isOpenPass = false;
            let isFacebook = false;
            let isDiscord = false;
            let isApple = false;
            let isTwitch = false;
            let isSteam = false;
            let commentCount = 0;
            let ratingCount = 0;
            let reviewCount = 0;
            let threadCount = 0;
            let followerCount = 0;
            let itemCount = 0;
            let isProfileVerified = "NO";
            let isPremium = "NO";
            let ln = item.accessPointUsers ? item.accessPointUsers.length : 0;
            let accessPointUser = ln > 0 ? item.accessPointUsers[0] : null;
            let onlyOneBrand = ln == 1;
            let displayNameStatus = "";
            let customDisplayImage = "";
            let customDisplayImageStatus = "";
            let coverImage = "";
            let coverImageStatus = "";
            let profilePageLink = "";
            let gender = "";
            let ageGroup = "";
            let country = "";
            let zipCode = "";

            if (accessPointUser) {
                userFullName = accessPointUser.firstName + " " + accessPointUser.lastName;
                displayName = accessPointUser.displayName;
                idProfile = accessPointUser.idProfile;
                isVerified = accessPointUser.isVerified;
                isAmazon = accessPointUser.isAmazon;
                isGoogle = accessPointUser.isGoogle;
                isOpenPass = accessPointUser.isOpenPass;
                isFacebook = accessPointUser.isFacebook;
                isDiscord = accessPointUser.isDiscord;
                isApple = accessPointUser.isApple;
                isTwitch = accessPointUser.isTwitch;
                isSteam = accessPointUser.isSteam;
                commentCount = accessPointUser.commentCount;
                ratingCount = accessPointUser.followTagsCount;
                reviewCount = accessPointUser.reviewCount;
                threadCount = accessPointUser.threadCount;
                followerCount = accessPointUser.followerCount;
                itemCount = accessPointUser.itemsInListsCount;
                isPremium = accessPointUser.isPremium ? 'Paid': (accessPointUser.isPremiumFree ? 'Free': 'No');
                isProfileVerified = accessPointUser.isProfileVerified ? 'Yes': 'No';
                gender = accessPointUser.gender || "";
                ageGroup = accessPointUser.ageGroup || "";
                country = accessPointUser.country || "";
                zipCode = accessPointUser.zipCode || "";

                if(accessPointUser.displayName) {
                    displayNameStatus = "Approved";
                }

                if(displayNameModeration[accessPointUser.id]){
                    let status = displayNameModeration[accessPointUser.id].status;
                    if(status && status.name){
                        displayName = displayNameModeration[accessPointUser.id].pendingDisplayName;
                        displayNameStatus = status.name;
                    }
                }

                if(accessPointUser.customProfilePicture) {
                    customDisplayImage = accessPointUser.customProfilePicture;
                    if(accessPointUser.isCustomProfilePictureValidated) {
                        customDisplayImageStatus = "Approved";
                    } else {
                        customDisplayImageStatus = "Submitted";
                    }
                }

                if(displayImageModeration[accessPointUser.id]){
                    let systemModerationOutcome = displayImageModeration[accessPointUser.id].systemModerationOutcome;
                    if(systemModerationOutcome && systemModerationOutcome.name){
                        customDisplayImageStatus = systemModerationOutcome.name;
                    }
                }

                if(accessPointUser.coverImage) {
                    coverImage = accessPointUser.coverImage;
                    if(accessPointUser.isCoverImageValidated) {
                        coverImageStatus = "Approved";
                    } else {
                        coverImageStatus = "Submitted";
                    }
                }

                if(coverImageModeration[accessPointUser.id]){
                    let systemModerationOutcome = coverImageModeration[accessPointUser.id].systemModerationOutcome;
                    if(systemModerationOutcome && systemModerationOutcome.name){
                        coverImageStatus = systemModerationOutcome.name;
                    }
                }
            }

            // Get all access point users
            let userAccessPoints = [];
            userAccessPoints = item.accessPointUsers.flatMap(obj => [{
                'accessPointUserId' : obj.id,
                'accessPointId' : obj.accessPoint.id,
                'accessPointName': obj.accessPoint.name,
                'active' : false,
                'brand': obj.accessPoint.brands.length > 0 ? obj.accessPoint.brands[0] : null
            }]);

            // get public profile page link
            let brandDomain = userAccessPoints.length > 0 && userAccessPoints[0].brand ? userAccessPoints[0].brand.domain : null;
            if(brandDomain && idProfile){
                // Ensure brand_domain includes the protocol
                if (!/^https?:\/\//i.test(brandDomain)) {
                    brandDomain = 'https://' + brandDomain;
                }
                profilePageLink = brandDomain + "/profile/" + idProfile;
            }

            let accessibleBrandIds = this.elementsList.getTemplateViewModel().accessibleBrandIds();
            let canDelete = !accessibleBrandIds || item.accessPointUsers.every(accessPointUser => accessPointUser.accessPoint.brands.some(brand => accessibleBrandIds.includes(Number(brand.id))));

            usersToSet.push( {
                idProfile: idProfile,
                isVerified: isVerified ? "true" : "false",
                isProfileVerified: isProfileVerified,
                isPremium: isPremium,
                isAmazon: isAmazon,
                isGoogle: isGoogle,
                isOpenPass: isOpenPass,
                isFacebook: isFacebook,
                isDiscord: isDiscord,
                isApple: isApple,
                isTwitch: isTwitch,
                isSteam: isSteam,
                commentCount: commentCount || 0,
                ratingCount: ratingCount || 0,
                reviewCount: reviewCount || 0,
                threadCount: threadCount || 0,
                followerCount: followerCount || 0,
                itemCount: itemCount || 0,
                fullName: userFullName,
                displayName: displayName,
                displayNameStatus: displayNameStatus,
                customDisplayImage: customDisplayImage,
                customDisplayImageStatus: customDisplayImageStatus,
                coverImage: coverImage,
                coverImageStatus: coverImageStatus,
                id: item.id,
                email: item.email,
                isEmakiUser: item.isEmakiUser ? "true" : "false",
                dateCreated: item.dateCreated ? item.dateCreated : {
                    date: "1970-01-01 00:00:00.000000",
                    timezone: "America/New_York",
                    timezone_type: 3
                },
                accessPoints: userAccessPoints,
                itemLink: window.location.origin + "/website-users/edit/" + item.id,
                profilePageLink: profilePageLink,
                gender: gender,
                ageGroup: ageGroup,
                country: country,
                zipCode: zipCode
                , canDelete: canDelete
            });
        }


        this.elementsList.setUsers(usersToSet);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setExecutionTime(execTime);
    }

    protected updateCount(responseParsed: any) {

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime, false );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);
        this.elementsList.setPaginationIsVisible(true);
    }

    protected getWebsiteUserById(data) {

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let url : string = '/api/website-users/get/' + data.id+ '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetWebsiteUserByIdReturn;
        this.XHRHdl.execute();
    }

    private onGetWebsiteUserByIdReturn(req, obj) {

        return function () {

            if(req.request.readyState === 4){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed && responseParsed.websiteUser) {

                    obj.elementsList.setWebsiteUserToDelete(responseParsed.websiteUser);
                    obj.elementsList.setThreadSuggestions(responseParsed.threadSuggestions);
                    obj.elementsList.toggleDeleteDialogVisibility('website-user-delete-dialog');

                } else {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Website User not found !");
                }
            };

            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected deleteWebsiteUser(data) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        //clear validations
        this.validationTemplate.clearMessages();


        let formReq_url = "/api/website-users/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getTemplateViewModel().websiteUserToDelete()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let idElement = 'website-user-delete-dialog-content';
        let threadSuggestionsToDelete = this.elementsList.getTemplateViewModel().threadSuggestionsToDelete();
        if(threadSuggestionsToDelete && threadSuggestionsToDelete.length > 0){
            idElement = 'thread-suggestions-delete-dialog-content';
        }

        this.loadingIn(document.getElementById(idElement));

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                if(req.request.readyState === 4){

                    let responseParsed = JSON.parse(req.request.response);

                    if (req.request.status == 200) {

                        if(responseParsed && responseParsed.warning){
                            obj.elementsList.reset();
                            obj.validationTemplate.setMessages([responseParsed.warning]);
                            setTimeout( () => {
                                obj.validationTemplate.clearMessages();
                            }, 10000)
                        }else{
                            obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Website user is successfully deleted");
                            let websiteUserId = obj.elementsList.getTemplateViewModel().websiteUserToDelete().id;
                            obj.releaseLock(websiteUserId);
                            obj.getVnAppZone().showNotificationToModule();
                            obj.elementsList.reset();
                            obj.filterList();
                        }

                    }else if (req.request.status == 400) {

                        obj.validationTemplate.setMessages(responseParsed.validations);
                        window.scrollTo(0, 0);
                        obj.loaderActive = false;
                    }else if (req.request.status == 423) {

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        obj.getVnAppZone().showNotificationToModule();
                    }

                    obj.loadingOut(document.getElementById(idElement));
                }
            }
        });
        XHRHdl.execute();
    }

    // preset filter methods
    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected releaseLock(idWebsiteUser) {

        // request a lock release
        let usrReq_url: string = '/api/website-users/release/' + idWebsiteUser;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    private toggleUserFilter(){

        let selectedItems = this.elementsList.getTemplateViewModel().brandFilter.selectedItems();
        if(selectedItems.length != 1){
            this.elementsList.getTemplateViewModel().userFilter.disabled(true);
            this.elementsList.getTemplateViewModel().userFilter.users([]);
        }else{
            this.elementsList.getTemplateViewModel().userFilter.disabled(false);
        }
    }

    protected onClickExportCsv(): void {
        let selectedBrands = this.elementsList.getTemplateViewModel().brandFilter.selectedItems();
        if (selectedBrands.length !== 1) return;

        let idBrands = this.elementsList.getTemplateViewModel().brandFilter.selectedItems();
        
        if (idBrands && idBrands.length != 1)
        	return;
         
        let idBrand = Number(typeof idBrands[0] === 'object' ? idBrands[0].id : idBrands[0]);
        if (!idBrand || isNaN(idBrand)) {
            return;
        }
        let baseRequestData = ko.toJS(this.elementsList.getViewModelForRequest());
        const exportPageSize = 100000;
        this.isExportCancelled = false;
        this.elementsList.setExportCancelling(false);
        this.elementsList.setExportModalVisible(true);

        const onError = (message: string) => {
            this.resetExportState();
            this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
            this.getVnAppZone().showNotificationToModule();
        };

        const runExport = async () => {
            try {
                this.elementsList.setExportState(true, 'Preparing export...');

                let allUsers = [];
                let offset = 0;
                let batchNumber = 0;

                while (true) {
                    if (this.isExportCancelled) {
                        throw new Error(this.EXPORT_CANCELLED_ERROR);
                    }

                    batchNumber++;
                    this.elementsList.setExportState(true, 'Loading batch ' + batchNumber + ' (offset ' + offset + ')...');

                    const batch = await this.fetchExportBatch(idBrand, baseRequestData, offset, exportPageSize);

                    if (this.isExportCancelled) {
                        throw new Error(this.EXPORT_CANCELLED_ERROR);
                    }

                    allUsers = allUsers.concat(batch);

                    if (batch.length < exportPageSize) {
                        break;
                    }

                    offset += exportPageSize;
                }

                this.elementsList.setExportState(true, 'Generating CSV...');
                let csv = this.buildExportCsv(allUsers);
                const allBrands = this.elementsList.getTemplateViewModel().brandFilter.items();
                const brandItem = allBrands.find((b: any) => b.id == idBrand);
                const brandName = brandItem ? brandItem.name : String(idBrand);
                const exportDate = new Date().toISOString().slice(0, 10);
                const fileName = brandName + ' Website User Data ' + exportDate + '.csv';
                this.downloadCsv(csv, fileName);
                this.resetExportState();
            } catch (error) {
                const exportError: any = error;
                if (exportError && exportError.message === this.EXPORT_CANCELLED_ERROR) {
                    this.resetExportState();
                    return;
                }
                onError('Failed to export website users.');
            }
        };

        runExport();
    }

    private fetchExportBatch(idBrand: number, baseRequestData: any, offset: number, limit: number): Promise<any[]> {
        return new Promise((resolve, reject) => {
            const requestData = JSON.parse(JSON.stringify(baseRequestData || {}));
            requestData.limit = limit;
            requestData.offset = offset;

            let xhr = new XMLHttpRequest();
            this.trackExportXhr(xhr);
            xhr.open('POST', '/api/brand/' + idBrand + '/website-users/export-csv/', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.responseType = 'json';

            xhr.onload = () => {
                this.untrackExportXhr(xhr);
                if (xhr.status !== 200) {
                    reject(new Error('Export request failed with status ' + xhr.status));
                    return;
                }

                try {
                    let response = xhr.response;
                    if (!response && xhr.responseText) {
                        response = JSON.parse(xhr.responseText);
                    }

                    const paginatedResults = (response && response.paginatedResults) ? response.paginatedResults : {};
                    const pageData = paginatedResults.data || [];
                    const users = Array.isArray(pageData.users) ? pageData.users : (Array.isArray(pageData) ? pageData : []);

                    resolve(users);
                } catch (error) {
                    reject(new Error('Failed to parse export response.'));
                }
            };

            xhr.onerror = () => {
                this.untrackExportXhr(xhr);
                if (this.isExportCancelled) {
                    reject(new Error(this.EXPORT_CANCELLED_ERROR));
                    return;
                }
                reject(new Error('Export request network error.'));
            };

            xhr.onabort = () => {
                this.untrackExportXhr(xhr);
                reject(new Error(this.EXPORT_CANCELLED_ERROR));
            };

            xhr.send(JSON.stringify({ data: requestData }));
        });
    }

    protected onClickCancelExport(): void {
        if (!this.elementsList.getTemplateViewModel().isExporting()) {
            this.elementsList.setExportModalVisible(false);
            return;
        }
        this.isExportCancelled = true;
        this.elementsList.setExportCancelling(true);
        this.elementsList.setExportState(true, 'Cancelling export...');
        this.abortActiveExportXhrs();
    }

    private trackExportXhr(xhr: XMLHttpRequest): void {
        this.activeExportXhrs.push(xhr);
    }

    private untrackExportXhr(xhr: XMLHttpRequest): void {
        this.activeExportXhrs = this.activeExportXhrs.filter((activeXhr) => activeXhr !== xhr);
    }

    private abortActiveExportXhrs(): void {
        for (const xhr of this.activeExportXhrs) {
            try {
                xhr.abort();
            } catch (error) {
                // no-op
            }
        }
        this.activeExportXhrs = [];
    }

    private resetExportState(): void {
        this.isExportCancelled = false;
        this.abortActiveExportXhrs();
        this.elementsList.setExportState(false, '');
        this.elementsList.setExportCancelling(false);
        this.elementsList.setExportModalVisible(false);
    }

    private buildExportCsv(users: any[]): string {
        const headers = ['First Name', 'Last Name', 'Email', 'Profile ID', 'Gender', 'Profession', 'Age Group', 'Country', 'Postal/ZIP Code'];
        const rows = users.map((user) => [
            user.firstName || '',
            user.lastName  || '',
            user.email     || '',
            user.idProfile || '',
            user.gender    || '',
            user.profession || '',
            user.ageGroup  || '',
            user.country   || '',
            user.zipCode   || '',
        ]);

        return [headers, ...rows]
            .map((row) => row.map((cell) => this.escapeCsvCell(cell)).join(','))
            .join('\r\n');
    }

    private escapeCsvCell(value: any): string {
        const strValue = value === null || value === undefined ? '' : String(value);
        if (/[",\n\r]/.test(strValue)) {
            return '"' + strValue.replace(/"/g, '""') + '"';
        }
        return strValue;
    }

    private downloadCsv(csv: string, fileName: string): void {
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let idBrands = this.elementsList.getTemplateViewModel().brandFilter.selectedItems();
        let subViewModel = {list: {keyword: keyword}, idElement: idElement, idBrand: idBrands[0]};
        let usrReq_url: string = '/api/search/website-users/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        obj.elementsList.userFilter.setUsers(responseParsed.data.users);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                // LOADING : ends
                obj.elementsList.deactivateLoading();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/website_users.ts